import { z } from 'zod/v4';

export const companyEmailSettingsSchema = z.array(
  z.object({
    email: z.string(),
    mapSchedulerNotification: z.boolean(),
  })
);

export type CompanyEmailSettings = z.infer<typeof companyEmailSettingsSchema>;
